<template>
  <div>
    <!-- <h5 class="checkout-h5 confirmation-title grey--text">
      FORMA DE RECEBIMENTO
    </h5> -->
    <v-layout style="align-items: center">
      <v-flex xs1 class="mr-2 pb-3">
        <v-icon v-if="itsPartialPayment" color="#192b46">error_outline</v-icon>
        <v-img
          v-else
          flat
          class="mt-1"
          src="https://cdn.blueticket.com.br/assets/icons/Ticket.svg"
          width="20"
        ></v-img>
        <!-- <v-icon v-else  color="primary">mdi-close</v-icon> -->
      </v-flex>
      <v-flex>
        <confirmation-local-print v-if="deliveryOption === 4" />
        <confirmation-checkin v-if="deliveryOption === 3" />
        <confirmation-eticket-print v-if="deliveryOption === 2" />
        <confirmation-eticket
          v-if="deliveryOption === 1"
          :itsPartialPayment="itsPartialPayment"
          :ticketUrl="ticketUrl"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import ConfirmationEticket from './ConfirmationEticket';
import ConfirmationCheckin from './ConfirmationCheckin';
import ConfirmationEticketPrint from './ConfirmationEticketPrint';
import ConfirmationLocalPrint from './ConfirmationLocalPrint';
import { mapGetters } from 'vuex';

export default {
  components: {
    ConfirmationEticket,
    ConfirmationCheckin,
    ConfirmationEticketPrint,
    ConfirmationLocalPrint,
  },
  props: ['ticketUrl', 'orderUrl'],
  computed: {
    ...mapGetters([
      'partialValue',
      'orderPdvData',
      'paymentData',
      'cartProducts',
    ]),
    itsPartialPayment() {
      if (
        this.$route.name !== 'commissioner' &&
        this.paymentData &&
        this.paymentData.split_payment &&
        this.productsTotal &&
        this.partialValue < this.productsTotal
      )
        return Number(this.productsTotal);
      if (
        this.$route.name === 'commissioner' &&
        this.orderPdvData &&
        this.orderPdvData.valor_pendente &&
        this.partialValue < Number(this.orderPdvData.valor_pendente)
      )
        return Number(this.orderPdvData.valor_pendente);
      return 0;
    },
    productsTotal() {
      let total = 0;
      let somador = 0;
      this.cartProducts.forEach(p => {
        p.forEach(v => {
          somador += (v.valor + v.valor_conveniencia) * v.quantidade;
        });
      });
      total = somador;
      return total;
    },
    deliveryOption() {
      return this.$store.getters.deliveryOption;
    },
  },
};
</script>
